import { render, staticRenderFns } from "./ArmazenamentoTable.vue?vue&type=template&id=5fadbca2&"
import script from "./ArmazenamentoTable.vue?vue&type=script&lang=js&"
export * from "./ArmazenamentoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports